import { useSelector } from "react-redux";
import { getIncompleteOnboardingFlows } from "../../redux/slices/accountSlice";
import { OnboardingFlowType } from "@markit/common.types";
import { Colors } from "../../utils/colors";
import "../../css/Onboarding.css";

type OnboardingFlowDotProps = {
  // Shows the dot if any of these flow types still have an incomplete webapp onboarding flow
  flowTypes: OnboardingFlowType[];
};

// Small indicator dot signaling there's an onboarding tour still to complete.
// Plug in anywhere (sidebar nav items, buttons, etc.) with the relevant flow type(s).
const OnboardingFlowDot = (props: OnboardingFlowDotProps) => {
  const { flowTypes } = props;
  const incompleteOnboardingFlows = useSelector(getIncompleteOnboardingFlows);

  const hasIncompleteFlow = incompleteOnboardingFlows.some((flow) =>
    flowTypes.includes(flow.id)
  );

  if (!hasIncompleteFlow) {
    return null;
  }

  return (
    <div style={{ position: "relative", width: 8, height: 8, flexShrink: 0 }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: 100,
          backgroundColor: Colors.BLUE5,
          animation:
            "onboarding-dot-ping 1.8s cubic-bezier(0, 0, 0.2, 1) infinite",
        }}
      />
      <div
        style={{
          position: "relative",
          width: 8,
          height: 8,
          borderRadius: 100,
          backgroundColor: Colors.BLUE5,
        }}
      />
    </div>
  );
};

export default OnboardingFlowDot;
